import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { rewardsAuthApiClientToken } from "../../../tokens";
import type {
    RewardsVipTierProgressResponseType,
    RewardsVipTiersResponseType,
} from "../models/RewardsVipTiersEntities";
import {
    RewardsVipTierProgressResponseSchema,
    RewardsVipTiersResponseSchema,
} from "../models/RewardsVipTiersSchemas";
import type { RewardsVipTiersQueryParams } from "../types";

@singleton()
class RewardsVipTiersApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    public getTiers(
        queryParams: RewardsVipTiersQueryParams
    ): Observable<RewardsVipTiersResponseType> {
        return this.apiClient
            .get({
                url: "/tiers/getTiers",
                queryParams,
                responseType: "json",
            })
            .pipe(
                map((response) =>
                    create(response.body, RewardsVipTiersResponseSchema)
                )
            );
    }

    public getTierProgress(): Observable<RewardsVipTierProgressResponseType> {
        return this.apiClient
            .get({
                url: "/tiers/getTierProgress",
                responseType: "json",
            })
            .pipe(
                map((response) =>
                    create(response.body, RewardsVipTierProgressResponseSchema)
                )
            );
    }
}

export default RewardsVipTiersApiService;
